module.exports = __webpack_public_path__ + "c4cf7a2c98e88528c9ccaa274eb65a5e.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/lazy-4.png
// module id = 1615
// module chunks = 0